/* eslint-disable no-extra-boolean-cast */
import { Switch } from "@mui/material";
import MDBox from "components/Basics/MDBox";

const InputBoolean = ({ label, value, onChange, disabled, error, InputProps = {}, ...rest }) => {
	return (
		<MDBox
			mt={1}
			display="flex"
			justifyContent="space-between"
			alignItems="center"
			className="customSwitchContainer"
			onClick={e => {
				onChange(!Boolean(value));
			}}
			{...InputProps}
		>
			<span>{label}</span>
			<MDBox>
				<Switch disabled={disabled} checked={Boolean(value)} />
			</MDBox>
		</MDBox>
	);
};
export default InputBoolean;
